export const HIGH_PRIORITY = 100
export const REGULAR_PRIORITY = 50
export const LOW_PRIORITY = 1
